import { getDetailSize } from "~/util/cdn";
import Scene from "~/scene";
import SceneCoords from "./scene/common/coords";
import { Place as PanoPlace } from "@mapy/panorama/dist/panorama-private";

interface IOptions {
	width: number;
	height: number;
}

interface IParams {
	pitch: number;
	fov: number;
	yaw: number | string;
	width: number;
	height: number;
	pid: number;
}

/**
 * Tvorba nahledoveho obrazku do detailu
 */
Mapy.Pano.Image = class {
	_options: IOptions;

	_data: {
		coords: SceneCoords;
		place: PanoPlace;
	};

	_params: IParams;

	/**
	 * @param {PanoPlace} place
	 * @param {SceneCoords} [coords] Volitelne souradnice bodu, na ktery chceme koukat
	 */
	constructor(place, coords, options) {
		this._options = {
			width: 100,
			height: 100,
			...options,
		};

		this._data = {
			coords: coords,
			place: place,
		};

		this._params = null;
	}

	setPano() {
		const place = this._data.place;
		let yaw = 0;
		const placeCoords = place.getCoords();
		const coords = Scene.coordsFromWGS84(placeCoords[0], placeCoords[1]);
		const azimuth = coords.azimuth(this._data.coords);

		yaw = azimuth * Math.PI / 180;

		const size = getDetailSize();
		const params = {
			// def pitch, fov
			pitch: -0.066,
			fov: 1.570,
			yaw,
			// dimensions from detail
			width: size.width,
			height: size.height,
			pid: place.getId(),
		} as IParams;

		if (params.yaw !== 0) {
			params.yaw = (params.yaw as number).toFixed(3);
		}

		const img = new Image();

		img.crossOrigin = "anonymous";
		img.src = Mapy.Util.panoCompose(params);

		this._params = params;

		return img;
	}

	getParams() {
		return this._params;
	}
};
